import apiClient from "@/app/api/client";
import { endpoints } from "@/shared/api/endpoints";

export type GenerateContractResponse = {
	url: string;
	fileName: string;
	format: ContractFormat;
};

export type ContractFormat = "docx" | "pdf";

export async function generateContract(
	saleId: string,
	format: ContractFormat = "docx",
	force = false
): Promise<GenerateContractResponse> {
	const response = await apiClient
		.post<{ data: GenerateContractResponse }>(endpoints.contracts.generate, {
			saleId,
			format,
			force,
		})
		.catch((error) => {
			console.error("[ContractsApi] Failed to generate contract:", error);
			throw error;
		});
	return response.data.data;
}
